import React, { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';

import ListView from '../Common/ListView.react';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import NotificationListItem from './NotificationListItem.react';
import NotificationStore from '../../stores/NotificationStore';
import NotificationActions from '../../actions/NotificationActionCreator';

import buildContextMenu from '../Common/BuildContextMenu';


class NotificationList extends Component {

    constructor (props) {
        super(props);
        this.state = {
            notifications: [],
            actions: [],
            menuItems: [
                {
                    link: '/logout',
                    icon: <CancelIcon />,
                    label: 'Sign out',
                },

            ],
            links: {
                back: '/dashboard/notifications',
                edit: '',
            }
        };
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        NotificationStore.addChangeListener(this.onChange);
        NotificationActions.getAll();

        this.setState(
            assign({},
            this.state, {
                actions: buildContextMenu(this.state.menuItems, this.context.auth)
            }
        ));
    }

    componentWillUnmount() {
        NotificationStore.removeChangeListener(this.onChange);
    }

    render() {
        return (
            <ListView
                title="Notifications"
                actions={this.state.actions}
                items={this.state.notifications}
                itemDecorator={NotificationListItem}
                divider={false}
            />
        );
    }

    onChange() {
        this.setState({ notifications: NotificationStore.getAll()});
    }
}

NotificationList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default NotificationList;
